import { createContext, useContext } from "react";
import { VisitorSession } from "../utils/visitorIdentification";

export type AnalyticsContextState = {
  setUser: (id: string) => void;
  trackEvent: (name: string, data?: Record<string, unknown>) => void;
  setUserProperties: (properties: Record<string, unknown>) => void;
  identifyVisitor: (session: VisitorSession) => void;
};

export const AnalyticsContext = createContext<
  AnalyticsContextState | undefined
>(undefined);

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error(`AnalyticsContext is not provided`);
  }
  return context;
};
